import { Charts } from './Charts';
import ProductionTemporalChartsDataProvider from './contexts/ProductionTemporalChartsDataContext';

const ProductionTemporalWrapper = () => {
    return (
        <ProductionTemporalChartsDataProvider>
            <Charts />
        </ProductionTemporalChartsDataProvider>
    );
};

export default ProductionTemporalWrapper;
